import React from "react";

const LegalEditor = () => (
  <section className="w-full bg-white py-8 px-6">
    <h2 className="text-xl font-bold text-dark-1 mb-4">1. Éditeur du site</h2>
    <p>
      Le site <strong>GoNextMaker</strong> est édité par :<br />
      <strong>IROKO FABLAB</strong>
    </p>
    <ul className="list-disc list-inside text-light-1 mt-3 space-y-1">
      <li>Siège social : [adresse complète]</li>
      <li>Email : contact@gonextmaker.com</li>
      <li>Téléphone : +229 XX XX XX XX</li>
      <li>Représentant légal : [Nom, fonction]</li>
    </ul>
  </section>
);

export default LegalEditor;
